export const MEDIA_ORDER_SPREAD = 2 ** 10;

export const MEDIA_ORDER_OFFSET = 3;

export const MAX_MEDIA = 10;
